import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/siteData";

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 - Siden blev ikke fundet | NF-Polering</title>
        <meta name="description" content="Siden du leder efter findes desværre ikke hos NF-Polering." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-[70vh] bg-slate-900 text-white flex items-center justify-center py-20 px-4">
        <div className="max-w-xl w-full text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-cyan-500/20 text-cyan-400 text-3xl font-black border border-cyan-500/40">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            Beklager, siden blev ikke fundet
          </h1>

          <p className="text-slate-300 text-base leading-relaxed">
            Siden du leder efter er enten flyttet eller findes ikke længere. Du kan gå tilbage til forsiden eller udforske vores mest populære ydelser nedenfor.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-sm shadow-md transition-colors"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til Forsiden</span>
            </Link>

            <Link
              to="/vinduespudsning"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-colors"
            >
              <i className="fa-solid fa-sparkles text-cyan-400" aria-hidden="true" />
              <span>Vinduespolering</span>
            </Link>

            <Link
              to="/fliserens"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-colors"
            >
              <i className="fa-solid fa-water text-cyan-400" aria-hidden="true" />
              <span>Fliserens</span>
            </Link>
          </div>

          <div className="pt-8 border-t border-slate-800 text-xs text-slate-400">
            Har du brug for akut hjælp? Ring til os på{" "}
            <a href={COMPANY_INFO.phoneTel} className="font-bold text-cyan-400 hover:underline whitespace-nowrap">
              {COMPANY_INFO.phone}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
